<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="close-btn wh" fill="clear" style="cursor:pointer;" (click)="dismiss()"><img src="/assets/imgs/close-modal-white.png" alt="모달 닫기" /> </ion-button>
    </ion-buttons>

    <ion-title *ngIf="profiles.length > 0">
      <ion-note class="titleNote">{{currentViewIdx + 1}}/{{profiles.length}}</ion-note>
    </ion-title>

    <ion-buttons slot="end" *ngIf="isMe && profiles.length > 0">
      <ion-button class="close-btn wh deleteBtn" fill="clear" style="cursor:pointer;" (click)="deleteProfile()">삭제 {{ profiles.length }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="wrap">
    <swiper-container #swiperRefProfile *ngIf="true">
      
      <ng-container *ngIf="profiles.length < 1">
        <ng-container *ngIf="true && type == 'defaultProfiles'">
          <swiper-slide>
            <img style="height: auto; background-color: #dddddd" src="assets/imgs/user-basic.png" alt=""/>
          </swiper-slide>
        </ng-container>

        <ng-container *ngIf="true && type == 'bgProfiles'">
          <swiper-slide>
            <img style="height: auto; background-color: #dddddd" src="assets/imgs/edit-basic.png" alt="" />
          </swiper-slide>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="profiles.length > 0">
        <swiper-slide *ngFor="let item of profiles; let i = index">
          <img [src]="item.content" alt="" *ngIf="item.type == 'image'" />
          <video
            *ngIf="item.type == 'video'"
            [muted]="true"
            preload="auto"
            [poster]="item.thumbnail"
            width="100%"
            style="background-color: rgb(214, 214, 214)"
            [id]="'video_' + i"
            controls controlsList="nodownload" oncontextmenu="return false;"
          >
            <source [src]="item.content" />
          </video>
        </swiper-slide>
      </ng-container>

    </swiper-container>
  </div>
</ion-content>
